import {Alert, DialogTitle, IconButton, Stack} from "@mui/material";
import React, {useState} from "react";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import CloseIcon from "@mui/icons-material/Close";
import patientAvatar from "../avatar.png";
import Avatar from "@mui/material/Avatar";
import PropTypes from "prop-types";
import Button from "@mui/material/Button";
import {styled} from "@mui/material/styles";
import FilePresentOutlinedIcon from "@mui/icons-material/FilePresentOutlined";
import StarIcon from "@mui/icons-material/Star";
import GoogleMapReact from "google-map-react";
import {APPOINTMENT_STATUS, APPOINTMENT_TYPES} from "../../../constants/constants";
import dayjs from "dayjs";
import momentTz from "moment-timezone";

// const relativeTime = require('dayjs/plugin/relativeTime')
// const timezone = require('dayjs/plugin/timezone')
// const isBetween = require('dayjs/plugin/isBetween')
const relativeTime = require("dayjs/plugin/relativeTime");
const timezone = require("dayjs/plugin/timezone");
const isBetween = require("dayjs/plugin/isBetween");
const userTimeZone = localStorage.getItem("Time-Zone");
// dayjs.extend(relativeTime)
// dayjs.extend(timezone)
// dayjs.extend(isBetween)
// dayjs.tz.setDefault("Asia/Colombo")


const BootstrapDialog = styled(Dialog)(({theme}) => ({
    "& .MuiDialogContent-root": {
        padding: theme.spacing(2),
    },
    "& .MuiDialogActions-root": {
        padding: theme.spacing(2),
    },
    backdropFilter: "blur(2px)",
    backgroundColor: "rgba(255, 255, 255,0.1)",
}));

const BootstrapDialogTitle = (props) => {
    const {children, onClose, ...other} = props;
    return (
        <DialogTitle sx={{m: 0, p: 3}} {...other}>
            {children}
            {onClose ? (
                <IconButton
                    aria-label="close"
                    onClick={onClose}
                    sx={{
                        position: "absolute",
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                    }}
                >
                    <CloseIcon/>
                </IconButton>
            ) : null}
        </DialogTitle>
    );
};

BootstrapDialogTitle.propTypes = {
    children: PropTypes.node,
    onClose: PropTypes.func.isRequired,
};

const DetailsModal = ({
                          handleClose,
                          open,
                          appointment,
                          handleVideoCallOpen,
                          handleChangeAppointmentOpen,
                          handleCancelDialogOpen
                      }) => {
                        const [showAlert, setShowAlert] = useState(false);

                        const mapOptions = {
                          disableDefaultUI: false,
                          mapTypeControl: true,
                          streetViewControl: true,
                          zoom: 11,
                          center: { lat: 11.6068, lng: 77.9558 },
                          styles: [
                            {
                              featureType: "poi",
                              elementType: "labels",
                              stylers: [{ visibility: "on" }],
                            },
                          ],
                        };

                        const getAttachmentNameFromUrl = (url) => {
                          let last = url.substring(
                            url.lastIndexOf("/") + 1,
                            url.length
                          );
                          let splitted = last.split("?AWSAccessKeyId=");
                          return splitted[0];
                        };

                        // const appointmentTime = dayjs(
                        //     `${appointment.date} ${appointment.slotTime}`,
                        //     ['YYYY', 'YYYY-MM-DD', 'YYYY-MM-DD HH:mm:ss'],
                        //     true
                        // );

// const convertedAppointmentTime = momentTz.tz(appointment.slotTime, "UTC");

// // Convert to user's local timezone
// const appointmentTime = convertedAppointmentTime.clone().tz(userTimeZone);
const appointmentTime = momentTz.tz(appointment.slotTime, "UTC").tz(userTimeZone);
// console.log("Converted Appointment Time:", appointmentTime.format());



                        // const oneHourAgo = appointmentTime.subtract(1, "hour");
                        // const oneHourAfter = appointmentTime.add(1, "hour");
                        // const currentTime = dayjs();
                        const oneHourAgo = appointmentTime.clone().subtract(1, "hour");
                        const oneHourAfter = appointmentTime.clone().add(1, "hour");
                        const currentTime = momentTz();
                      
                        // console.log("Current Time:", currentTime.format());
                        // console.log("One Hour Ago:", oneHourAgo.format());
                        // console.log("One Hour After:", oneHourAfter.format());
                        return (
                          <BootstrapDialog
                            onClose={handleClose}
                            aria-labelledby="customized-dialog-title"
                            open={open}
                            fullWidth={true}
                            maxWidth={"md"}
                          >
                            <BootstrapDialogTitle
                              // @ts-ignore
                              id="customized-dialog-title"
                              onClose={handleClose}
                            >
                              <Stack direction="row" spacing={2}>
                                <div className="doctor-rating">
                                  <Avatar
                                    alt="Patient Avatar"
                                    src={patientAvatar}
                                    variant="rounded"
                                  />
                                  <div className="star-icon">
                                    <StarIcon style={{ fontSize: "12px" }} />
                                    <p>3.7</p>
                                  </div>
                                </div>
                                <div className="patientDetail">
                                  <h5>{appointment.purpose}</h5>
                                  <h6>{appointment.Doctor.name}</h6>
                                  <p>
                                    {/* Specialist{" "} */}
                                    {appointment.Doctor.serviceCategories.map(
                                      (e) => {
                                        return `${e}, `;
                                      }
                                    )}
                                  </p>
                                </div>
                              </Stack>
                              <div className="dialogTime">
                                <h6>
                                  {appointmentTime.fromNow()} at{" "}
                                  {appointmentTime.format("hh:mm A")}, in '{userTimeZone}' time
                                </h6>
                                <p>
                                  {appointment.appointmentType} |{" "}
                                  {appointment.purpose}
                                </p>
                              </div>
                              <div className="dialogTitle">
                                <h4>Patient Details</h4>
                              </div>
                            </BootstrapDialogTitle>
                            <DialogContent
                              dividers
                              className="dialogDivider d-flex"
                            >
                              <div className="dialogContent">
                                <p>Name</p>
                                <h4>{appointment.Patient.name}</h4>
                                <p>Medical Details </p>
                                <h4>{appointment.medicalDetails}</h4>
                                <p>Attachments</p>
                                <div className="attachment-main">
                                  {appointment?.attachments.length > 0 ? (
                                    appointment.attachments.map((e, i) => {
                                      return (
                                        <a
                                          key={"a" + i}
                                          className="attachment-file"
                                          href={e}
                                        >
                                          <FilePresentOutlinedIcon fontSize="small" />
                                          <p>{getAttachmentNameFromUrl(e)}</p>
                                        </a>
                                      );
                                    })
                                  ) : (
                                    <p>No Attachments </p>
                                  )}
                                </div>
                              </div>
                              {appointment.appointmentType ===
                                APPOINTMENT_TYPES.PHYSICAL && (
                                <div
                                  style={{
                                    height: "35vh",
                                    width: "60%",
                                    marginTop: "-10px",
                                  }}
                                >
                                  <GoogleMapReact
                                    bootstrapURLKeys={{
                                      key: "AIzaSyA_i_Oy27ypfFFlqoNcK1r1qA-zGS-yXSw",
                                    }}
                                    defaultCenter={mapOptions.center}
                                    defaultZoom={mapOptions.zoom}
                                    options={mapOptions}
                                  ></GoogleMapReact>
                                </div>
                              )}
                            </DialogContent>
                            <DialogActions>
                              {
                                appointment.status ===
                                  APPOINTMENT_STATUS.PENDING &&
                                  currentTime.isBefore(oneHourAgo) && (
                                    <Button
                                      autoFocus
                                      onClick={() => handleCancelDialogOpen()}
                                      className="dialogButton"
                                    >
                                      Cancel Appointment
                                    </Button>
                                  ) // </Button> //   Im in Location // <Button autoFocus className="dialogButton">
                              }
                              {appointment.status ===
                                APPOINTMENT_STATUS.PENDING &&
                                currentTime.isAfter(oneHourAfter) && (
                                  <Alert
                                    sx={{ marginRight: 2 }}
                                    severity="error"
                                  >
                                    Appointment Has Expired.
                                  </Alert>
                                )}

                              {showAlert && (
                                <Alert sx={{ marginRight: 2 }}>
                                  Appointment Will Start Soon
                                </Alert>
                              )}
                              {appointment.status !==
                              APPOINTMENT_STATUS.CANCELED && (
                                appointmentTime.isBetween(oneHourAgo, oneHourAfter) && (
                                  <>
                                    {appointment.appointmentType ===
                                    APPOINTMENT_TYPES.PHYSICAL ? (
                                      <Button
                                        autoFocus
                                        className="dialogButton"
                                        onClick={() => {
                                          setShowAlert(true);
                                        }}
                                      >
                                        Im in Location
                                      </Button>
                                    ) : (
                                      <Button
                                        autoFocus
                                        onClick={() =>
                                          handleVideoCallOpen(
                                            appointment.appointmentId
                                          )
                                        }
                                        className="dialogButton"
                                      >
                                        Go to Video Chat Waiting Room
                                      </Button>
                                    )}
                                    
                                  </>
                                )

                              //   ) : (
                              //     ""
                              //   )
                              // ) : (
                              //   // (
                              //   //   <Button
                              //   //     autoFocus
                              //   //     onClick={handleChangeAppointmentOpen}
                              //   //     className="dialogButton"
                              //   //   >
                              //   //     Request Change Appointments
                              //   //   </Button>
                              //   // )
                              //   <Alert sx={{ marginRight: 2 }} severity="error">
                              //     Cancelled
                              //   </Alert>
                              // )}
                            )}

                            {appointment.status === APPOINTMENT_STATUS.CANCELED && (
                              <Alert severity="error">Cancelled</Alert>
                            )}
                            </DialogActions>
                          </BootstrapDialog>
                        );
                      };

export default DetailsModal;
